/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramCategoryControllerFindOneByIdQueryResponse,
  TelegramCategoryControllerFindOneByIdPathParams,
  TelegramCategoryControllerFindOneById401,
  TelegramCategoryControllerFindOneById404,
} from '../../types/TelegramCategoryControllerFindOneById.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryFindOneById } from '../../methods/telegramCategoryFindOneById.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryFindOneByIdQueryKey = (id: TelegramCategoryControllerFindOneByIdPathParams['id']) =>
  [{ url: '/api/telegram/category/id/:id', params: { id: id } }] as const;

export type TelegramCategoryFindOneByIdQueryKey = ReturnType<typeof telegramCategoryFindOneByIdQueryKey>;

export function telegramCategoryFindOneByIdQueryOptions(
  id: TelegramCategoryControllerFindOneByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryFindOneByIdQueryKey(id);
  return queryOptions<
    TelegramCategoryControllerFindOneByIdQueryResponse,
    ResponseErrorConfig<TelegramCategoryControllerFindOneById401 | TelegramCategoryControllerFindOneById404>,
    TelegramCategoryControllerFindOneByIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryFindOneById(id, config);
    },
  });
}

/**
 * {@link /api/telegram/category/id/:id}
 */
export function useTelegramCategoryFindOneById<
  TData = TelegramCategoryControllerFindOneByIdQueryResponse,
  TQueryData = TelegramCategoryControllerFindOneByIdQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryFindOneByIdQueryKey,
>(
  id: TelegramCategoryControllerFindOneByIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerFindOneByIdQueryResponse,
        ResponseErrorConfig<TelegramCategoryControllerFindOneById401 | TelegramCategoryControllerFindOneById404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryFindOneByIdQueryKey(id);

  const query = useQuery(
    {
      ...telegramCategoryFindOneByIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<TelegramCategoryControllerFindOneById401 | TelegramCategoryControllerFindOneById404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
